












































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { availableReferralTypes } from '@/api/types'
import { ReferralNode } from '@/api/model/referral-node'
import { Company } from '@/api/model/company'
import { CompanyAPI } from '@/api/backend-client'
import { isUuid } from 'uuidv4'

@Component
export default class CreateReferralNodeForm extends Vue {
    @Prop({ required: true }) readonly value!: ReferralNode
    targetId: string = null
    targetCompany: Company = null
    loadingTargetCompany: boolean = false

    @Watch('targetId')
    async onTargetIdChanged() {
        await this.setTargetCompany(this.targetId)
    }

    async setTargetCompany(id: string) {
        if (isUuid(id)) {
            try {
                this.loadingTargetCompany = true
                this.targetId = id
                this.targetCompany = await CompanyAPI.get(id)

                // @ts-ignore
                this.value.target = this.targetCompany

            } finally {
                this.loadingTargetCompany = false
            }

            return
        }

        this.targetCompany = null
    }

    async askForTargetId() {
        await this.setTargetCompany(prompt(
            this.$t('forms.create-referral-node-form.prompt').toString(),
        ))
    }

    get referralTypeOptions() {
        return availableReferralTypes().map(referralType => {
            return {
                label: this.$t(`referral.type.${referralType}`),
                value: referralType,
            }
        })
    }

    get chosenCombinationExistsAlready(): boolean {
        if (!this.value || !this.value.type || !this.value.target) {
            return false
        }

        return this.$currentCompany.outgoingReferrals.some((node: ReferralNode) => {
            const target = (node.target instanceof Company) ? node.target.resourceIdentifier : node.target
            return node.type === this.value.type && target === this.value.target.resourceIdentifier
        })
    }
}
